"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
var actions_1 = require("../../utils/actions");
var actions_2 = require("./actions");
exports.initialState = {
    selected: '',
    methods: [],
};
var updateShippingMethods = function (state, action) {
    var shippingMethods = action.payload.shippingMethods;
    if (!shippingMethods) {
        return state;
    }
    return __assign(__assign({}, state), { methods: __spreadArray([], shippingMethods, true) });
};
var setSelectedShippingMethod = function (state, action) {
    var id = action.payload.id;
    return __assign(__assign({}, state), { selected: id });
};
var shippingMethodsReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    if ((0, actions_1.isType)(action, actions_2.updateShippingMethodsAction)) {
        return updateShippingMethods(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.setSelectedShippingMethodAction)) {
        return setSelectedShippingMethod(state, action);
    }
    else {
        return state;
    }
};
exports.default = shippingMethodsReducer;
